import { render, staticRenderFns } from "./internalUserRoles.vue?vue&type=template&id=26dd4d33&scoped=true&"
import script from "./internalUserRoles.vue?vue&type=script&lang=js&"
export * from "./internalUserRoles.vue?vue&type=script&lang=js&"
import style0 from "./internalUserRoles.vue?vue&type=style&index=0&id=26dd4d33&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dd4d33",
  null
  
)

export default component.exports